// Generated by scripts/gen-cities.mjs from the system time-zone table plus extra family cities. Do not edit.
export interface City {
  name: string;
  cc: string;
  tz: string;
  lat: number;
  lon: number;
}

const RAW: [string, string, string, number, number][] = [
  ["Abidjan","CI","Africa/Abidjan",5.32,-4.03],
  ["Accra","GH","Africa/Accra",5.55,-0.22],
  ["Adak","US","America/Adak",51.88,-176.66],
  ["Addis Ababa","ET","Africa/Addis_Ababa",9.03,38.7],
  ["Adelaide","AU","Australia/Adelaide",-34.92,138.58],
  ["Aden","YE","Asia/Aden",12.75,45.2],
  ["Algiers","DZ","Africa/Algiers",36.78,3.05],
  ["Almaty","KZ","Asia/Almaty",43.25,76.95],
  ["Amman","JO","Asia/Amman",31.95,35.93],
  ["Amsterdam","NL","Europe/Amsterdam",52.37,4.9],
  ["Anadyr","RU","Asia/Anadyr",64.75,177.48],
  ["Anchorage","US","America/Anchorage",61.22,-149.9],
  ["Andorra","AD","Europe/Andorra",42.5,1.52],
  ["Anguilla","AI","America/Anguilla",18.2,-63.07],
  ["Antananarivo","MG","Indian/Antananarivo",-18.92,47.52],
  ["Antigua","AG","America/Antigua",17.05,-61.8],
  ["Apia","WS","Pacific/Apia",-13.83,-171.73],
  ["Aqtau","KZ","Asia/Aqtau",44.52,50.27],
  ["Aqtobe","KZ","Asia/Aqtobe",50.28,57.17],
  ["Araguaina","BR","America/Araguaina",-7.2,-48.2],
  ["Arequipa","PE","America/Lima",-16.41,-71.54],
  ["Aruba","AW","America/Aruba",12.5,-69.97],
  ["Ashgabat","TM","Asia/Ashgabat",37.95,58.38],
  ["Asmara","ER","Africa/Asmara",15.33,38.88],
  ["Astrakhan","RU","Europe/Astrakhan",46.35,48.05],
  ["Asuncion","PY","America/Asuncion",-25.27,-57.67],
  ["Athens","GR","Europe/Athens",37.97,23.72],
  ["Atikokan","CA","America/Atikokan",48.76,-91.62],
  ["Atlanta","US","America/New_York",33.75,-84.39],
  ["Atyrau","KZ","Asia/Atyrau",47.12,51.93],
  ["Auckland","NZ","Pacific/Auckland",-36.87,174.77],
  ["Austin","US","America/Chicago",30.27,-97.74],
  ["Azores","PT","Atlantic/Azores",37.73,-25.67],
  ["Baghdad","IQ","Asia/Baghdad",33.35,44.42],
  ["Bahia","BR","America/Bahia",-12.98,-38.52],
  ["Bahia Banderas","MX","America/Bahia_Banderas",20.8,-105.25],
  ["Bahrain","BH","Asia/Bahrain",26.38,50.58],
  ["Baku","AZ","Asia/Baku",40.38,49.85],
  ["Baltimore","US","America/New_York",39.29,-76.61],
  ["Bamako","ML","Africa/Bamako",12.65,-8],
  ["Bangkok","TH","Asia/Bangkok",13.75,100.52],
  ["Bangui","CF","Africa/Bangui",4.37,18.58],
  ["Banjul","GM","Africa/Banjul",13.47,-16.65],
  ["Barbados","BB","America/Barbados",13.1,-59.62],
  ["Barcelona","ES","Europe/Madrid",41.39,2.17],
  ["Barnaul","RU","Asia/Barnaul",53.37,83.75],
  ["Beirut","LB","Asia/Beirut",33.88,35.5],
  ["Belem","BR","America/Belem",-1.45,-48.48],
  ["Belgrade","RS","Europe/Belgrade",44.83,20.5],
  ["Belize","BZ","America/Belize",17.5,-88.2],
  ["Berlin","DE","Europe/Berlin",52.5,13.37],
  ["Bermuda","BM","Atlantic/Bermuda",32.28,-64.77],
  ["Beulah","US","America/North_Dakota/Beulah",47.26,-101.78],
  ["Bishkek","KG","Asia/Bishkek",42.9,74.6],
  ["Bissau","GW","Africa/Bissau",11.85,-15.58],
  ["Blanc-Sablon","CA","America/Blanc-Sablon",51.42,-57.12],
  ["Blantyre","MW","Africa/Blantyre",-15.78,35],
  ["Boa Vista","BR","America/Boa_Vista",2.82,-60.67],
  ["Bogota","CO","America/Bogota",4.6,-74.08],
  ["Boise","US","America/Boise",43.61,-116.2],
  ["Boston","US","America/New_York",42.36,-71.06],
  ["Bougainville","PG","Pacific/Bougainville",-6.22,155.57],
  ["Brasília","BR","America/Sao_Paulo",-15.79,-47.88],
  ["Bratislava","SK","Europe/Bratislava",48.15,17.12],
  ["Brazzaville","CG","Africa/Brazzaville",-4.27,15.28],
  ["Brisbane","AU","Australia/Brisbane",-27.47,153.03],
  ["Broken Hill","AU","Australia/Broken_Hill",-31.95,141.45],
  ["Brunei","BN","Asia/Brunei",4.93,114.92],
  ["Brussels","BE","Europe/Brussels",50.83,4.33],
  ["Bucharest","RO","Europe/Bucharest",44.43,26.1],
  ["Budapest","HU","Europe/Budapest",47.5,19.08],
  ["Buenos Aires","AR","America/Argentina/Buenos_Aires",-34.6,-58.45],
  ["Buffalo","US","America/New_York",42.89,-78.88],
  ["Bujumbura","BI","Africa/Bujumbura",-3.38,29.37],
  ["Busingen","DE","Europe/Busingen",47.7,8.68],
  ["Cairo","EG","Africa/Cairo",30.05,31.25],
  ["Cali","CO","America/Bogota",3.45,-76.53],
  ["Cambridge Bay","CA","America/Cambridge_Bay",69.11,-105.05],
  ["Campo Grande","BR","America/Campo_Grande",-20.45,-54.62],
  ["Canary","ES","Atlantic/Canary",28.1,-15.4],
  ["Cancun","MX","America/Cancun",21.08,-86.77],
  ["Cape Verde","CV","Atlantic/Cape_Verde",14.92,-23.52],
  ["Caracas","VE","America/Caracas",10.5,-66.93],
  ["Cartagena","CO","America/Bogota",10.39,-75.51],
  ["Casablanca","MA","Africa/Casablanca",33.65,-7.58],
  ["Casey","AQ","Antarctica/Casey",-66.28,110.52],
  ["Catamarca","AR","America/Argentina/Catamarca",-28.47,-65.78],
  ["Cayenne","GF","America/Cayenne",4.93,-52.33],
  ["Cayman","KY","America/Cayman",19.3,-81.38],
  ["Center","US","America/North_Dakota/Center",47.12,-101.3],
  ["Ceuta","ES","Africa/Ceuta",35.88,-5.32],
  ["Chagos","IO","Indian/Chagos",-7.33,72.42],
  ["Charlotte","US","America/New_York",35.23,-80.84],
  ["Chatham","NZ","Pacific/Chatham",-43.95,-176.55],
  ["Chicago","US","America/Chicago",41.85,-87.65],
  ["Chiclayo","PE","America/Lima",-6.77,-79.84],
  ["Chihuahua","MX","America/Chihuahua",28.63,-106.08],
  ["Chisinau","MD","Europe/Chisinau",47,28.83],
  ["Chita","RU","Asia/Chita",52.05,113.47],
  ["Christmas","CX","Indian/Christmas",-10.42,105.72],
  ["Chuuk","FM","Pacific/Chuuk",7.42,151.78],
  ["Ciudad Juarez","MX","America/Ciudad_Juarez",31.73,-106.48],
  ["Cocos","CC","Indian/Cocos",-12.17,96.92],
  ["Colombo","LK","Asia/Colombo",6.93,79.85],
  ["Comoro","KM","Indian/Comoro",-11.68,43.27],
  ["Conakry","GN","Africa/Conakry",9.52,-13.72],
  ["Copenhagen","DK","Europe/Copenhagen",55.67,12.58],
  ["Cordoba","AR","America/Argentina/Cordoba",-31.4,-64.18],
  ["Costa Rica","CR","America/Costa_Rica",9.93,-84.08],
  ["Coyhaique","CL","America/Coyhaique",-45.57,-72.07],
  ["Creston","CA","America/Creston",49.1,-116.52],
  ["Cuiaba","BR","America/Cuiaba",-15.58,-56.08],
  ["Curacao","CW","America/Curacao",12.18,-69],
  ["Cusco","PE","America/Lima",-13.53,-71.97],
  ["Dakar","SN","Africa/Dakar",14.67,-17.43],
  ["Dallas","US","America/Chicago",32.78,-96.8],
  ["Damascus","SY","Asia/Damascus",33.5,36.3],
  ["Danmarkshavn","GL","America/Danmarkshavn",76.77,-18.67],
  ["Dar es Salaam","TZ","Africa/Dar_es_Salaam",-6.8,39.28],
  ["Darwin","AU","Australia/Darwin",-12.47,130.83],
  ["Davis","AQ","Antarctica/Davis",-68.58,77.97],
  ["Dawson","CA","America/Dawson",64.07,-139.42],
  ["Dawson Creek","CA","America/Dawson_Creek",55.77,-120.23],
  ["Denver","US","America/Denver",39.74,-104.98],
  ["Detroit","US","America/Detroit",42.33,-83.05],
  ["Dhaka","BD","Asia/Dhaka",23.72,90.42],
  ["Dili","TL","Asia/Dili",-8.55,125.58],
  ["Djibouti","DJ","Africa/Djibouti",11.6,43.15],
  ["Dominica","DM","America/Dominica",15.3,-61.4],
  ["Douala","CM","Africa/Douala",4.05,9.7],
  ["Dubai","AE","Asia/Dubai",25.3,55.3],
  ["Dublin","IE","Europe/Dublin",53.33,-6.25],
  ["DumontDUrville","AQ","Antarctica/DumontDUrville",-66.67,140.02],
  ["Dushanbe","TJ","Asia/Dushanbe",38.58,68.8],
  ["Easter","CL","Pacific/Easter",-27.15,-109.43],
  ["Edmonton","CA","America/Edmonton",53.55,-113.47],
  ["Efate","VU","Pacific/Efate",-17.67,168.42],
  ["Eirunepe","BR","America/Eirunepe",-6.67,-69.87],
  ["El Aaiun","EH","Africa/El_Aaiun",27.15,-13.2],
  ["El Salvador","SV","America/El_Salvador",13.7,-89.2],
  ["Elizabeth","US","America/New_York",40.66,-74.21],
  ["Eucla","AU","Australia/Eucla",-31.72,128.87],
  ["Fakaofo","TK","Pacific/Fakaofo",-9.37,-171.23],
  ["Famagusta","CY","Asia/Famagusta",35.12,33.95],
  ["Faroe","FO","Atlantic/Faroe",62.02,-6.77],
  ["Fiji","FJ","Pacific/Fiji",-18.13,178.42],
  ["Fort Lauderdale","US","America/New_York",26.12,-80.14],
  ["Fort Nelson","CA","America/Fort_Nelson",58.8,-122.7],
  ["Fortaleza","BR","America/Fortaleza",-3.72,-38.5],
  ["Freetown","SL","Africa/Freetown",8.5,-13.25],
  ["Funafuti","TV","Pacific/Funafuti",-8.52,179.22],
  ["Gaborone","BW","Africa/Gaborone",-24.65,25.92],
  ["Galapagos","EC","Pacific/Galapagos",-0.9,-89.6],
  ["Gambier","PF","Pacific/Gambier",-23.13,-134.95],
  ["Gaza","PS","Asia/Gaza",31.5,34.47],
  ["Gibraltar","GI","Europe/Gibraltar",36.13,-5.35],
  ["Glace Bay","CA","America/Glace_Bay",46.2,-59.95],
  ["Goose Bay","CA","America/Goose_Bay",53.33,-60.42],
  ["Grand Turk","TC","America/Grand_Turk",21.47,-71.13],
  ["Grenada","GD","America/Grenada",12.05,-61.75],
  ["Guadalajara","MX","America/Mexico_City",20.66,-103.35],
  ["Guadalcanal","SB","Pacific/Guadalcanal",-9.53,160.2],
  ["Guadeloupe","GP","America/Guadeloupe",16.23,-61.53],
  ["Guam","GU","Pacific/Guam",13.47,144.75],
  ["Guatemala","GT","America/Guatemala",14.63,-90.52],
  ["Guayaquil","EC","America/Guayaquil",-2.17,-79.83],
  ["Guernsey","GG","Europe/Guernsey",49.45,-2.54],
  ["Guyana","GY","America/Guyana",6.8,-58.17],
  ["Halifax","CA","America/Halifax",44.65,-63.6],
  ["Harare","ZW","Africa/Harare",-17.83,31.05],
  ["Hartford","US","America/New_York",41.76,-72.67],
  ["Havana","CU","America/Havana",23.13,-82.37],
  ["Hebron","PS","Asia/Hebron",31.53,35.1],
  ["Helsinki","FI","Europe/Helsinki",60.17,24.97],
  ["Hermosillo","MX","America/Hermosillo",29.07,-110.97],
  ["Ho Chi Minh","VN","Asia/Ho_Chi_Minh",10.75,106.67],
  ["Hobart","AU","Australia/Hobart",-42.88,147.32],
  ["Hoboken","US","America/New_York",40.74,-74.03],
  ["Hong Kong","HK","Asia/Hong_Kong",22.28,114.15],
  ["Honolulu","US","Pacific/Honolulu",21.31,-157.86],
  ["Houston","US","America/Chicago",29.76,-95.37],
  ["Hovd","MN","Asia/Hovd",48.02,91.65],
  ["Indianapolis","US","America/Indiana/Indianapolis",39.77,-86.16],
  ["Inuvik","CA","America/Inuvik",68.35,-133.72],
  ["Iqaluit","CA","America/Iqaluit",63.73,-68.47],
  ["Iquitos","PE","America/Lima",-3.75,-73.25],
  ["Irkutsk","RU","Asia/Irkutsk",52.27,104.33],
  ["Isle of Man","IM","Europe/Isle_of_Man",54.15,-4.47],
  ["Istanbul","TR","Europe/Istanbul",41.02,28.97],
  ["Jakarta","ID","Asia/Jakarta",-6.17,106.8],
  ["Jamaica","JM","America/Jamaica",17.97,-76.79],
  ["Jayapura","ID","Asia/Jayapura",-2.53,140.7],
  ["Jersey","JE","Europe/Jersey",49.18,-2.11],
  ["Jersey City","US","America/New_York",40.72,-74.08],
  ["Jerusalem","IL","Asia/Jerusalem",31.78,35.22],
  ["Johannesburg","ZA","Africa/Johannesburg",-26.25,28],
  ["Juba","SS","Africa/Juba",4.85,31.62],
  ["Jujuy","AR","America/Argentina/Jujuy",-24.18,-65.3],
  ["Juneau","US","America/Juneau",58.3,-134.42],
  ["Kabul","AF","Asia/Kabul",34.52,69.2],
  ["Kaliningrad","RU","Europe/Kaliningrad",54.72,20.5],
  ["Kamchatka","RU","Asia/Kamchatka",53.02,158.65],
  ["Kampala","UG","Africa/Kampala",0.32,32.42],
  ["Kanton","KI","Pacific/Kanton",-2.78,-171.72],
  ["Karachi","PK","Asia/Karachi",24.87,67.05],
  ["Kathmandu","NP","Asia/Kathmandu",27.72,85.32],
  ["Kerguelen","TF","Indian/Kerguelen",-49.35,70.22],
  ["Khandyga","RU","Asia/Khandyga",62.66,135.55],
  ["Khartoum","SD","Africa/Khartoum",15.6,32.53],
  ["Kigali","RW","Africa/Kigali",-1.95,30.07],
  ["Kinshasa","CD","Africa/Kinshasa",-4.3,15.3],
  ["Kiritimati","KI","Pacific/Kiritimati",1.87,-157.33],
  ["Kirov","RU","Europe/Kirov",58.6,49.65],
  ["Knox","US","America/Indiana/Knox",41.3,-86.62],
  ["Kolkata","IN","Asia/Kolkata",22.53,88.37],
  ["Kosrae","FM","Pacific/Kosrae",5.32,162.98],
  ["Kralendijk","BQ","America/Kralendijk",12.15,-68.28],
  ["Krasnoyarsk","RU","Asia/Krasnoyarsk",56.02,92.83],
  ["Kuala Lumpur","MY","Asia/Kuala_Lumpur",3.17,101.7],
  ["Kuching","MY","Asia/Kuching",1.55,110.33],
  ["Kuwait","KW","Asia/Kuwait",29.33,47.98],
  ["Kwajalein","MH","Pacific/Kwajalein",9.08,167.33],
  ["Kyiv","UA","Europe/Kyiv",50.43,30.52],
  ["La Paz","BO","America/La_Paz",-16.5,-68.15],
  ["La Rioja","AR","America/Argentina/La_Rioja",-29.43,-66.85],
  ["Lagos","NG","Africa/Lagos",6.45,3.4],
  ["Las Vegas","US","America/Los_Angeles",36.17,-115.14],
  ["Libreville","GA","Africa/Libreville",0.38,9.45],
  ["Lima","PE","America/Lima",-12.05,-77.05],
  ["Lindeman","AU","Australia/Lindeman",-20.27,149],
  ["Lisbon","PT","Europe/Lisbon",38.72,-9.13],
  ["Ljubljana","SI","Europe/Ljubljana",46.05,14.52],
  ["Lome","TG","Africa/Lome",6.13,1.22],
  ["London","GB","Europe/London",51.51,-0.13],
  ["Longyearbyen","SJ","Arctic/Longyearbyen",78,16],
  ["Lord Howe","AU","Australia/Lord_Howe",-31.55,159.08],
  ["Los Angeles","US","America/Los_Angeles",34.05,-118.24],
  ["Louisville","US","America/Kentucky/Louisville",38.25,-85.76],
  ["Lower Princes","SX","America/Lower_Princes",18.05,-63.05],
  ["Luanda","AO","Africa/Luanda",-8.8,13.23],
  ["Lubumbashi","CD","Africa/Lubumbashi",-11.67,27.47],
  ["Lusaka","ZM","Africa/Lusaka",-15.42,28.28],
  ["Luxembourg","LU","Europe/Luxembourg",49.6,6.15],
  ["Macau","MO","Asia/Macau",22.2,113.54],
  ["Maceio","BR","America/Maceio",-9.67,-35.72],
  ["Macquarie","AU","Antarctica/Macquarie",-54.5,158.95],
  ["Madeira","PT","Atlantic/Madeira",32.63,-16.9],
  ["Madrid","ES","Europe/Madrid",40.4,-3.68],
  ["Magadan","RU","Asia/Magadan",59.57,150.8],
  ["Mahe","SC","Indian/Mahe",-4.67,55.47],
  ["Majuro","MH","Pacific/Majuro",7.15,171.2],
  ["Makassar","ID","Asia/Makassar",-5.12,119.4],
  ["Malabo","GQ","Africa/Malabo",3.75,8.78],
  ["Maldives","MV","Indian/Maldives",4.17,73.5],
  ["Malta","MT","Europe/Malta",35.9,14.52],
  ["Managua","NI","America/Managua",12.15,-86.28],
  ["Manaus","BR","America/Manaus",-3.13,-60.02],
  ["Manila","PH","Asia/Manila",14.59,120.97],
  ["Maputo","MZ","Africa/Maputo",-25.97,32.58],
  ["Marengo","US","America/Indiana/Marengo",38.38,-86.34],
  ["Mariehamn","AX","Europe/Mariehamn",60.1,19.95],
  ["Marigot","MF","America/Marigot",18.07,-63.08],
  ["Marquesas","PF","Pacific/Marquesas",-9,-139.5],
  ["Martinique","MQ","America/Martinique",14.6,-61.08],
  ["Maseru","LS","Africa/Maseru",-29.47,27.5],
  ["Matamoros","MX","America/Matamoros",25.83,-97.5],
  ["Mauritius","MU","Indian/Mauritius",-20.17,57.5],
  ["Mawson","AQ","Antarctica/Mawson",-67.6,62.88],
  ["Mayotte","YT","Indian/Mayotte",-12.78,45.23],
  ["Mazatlan","MX","America/Mazatlan",23.22,-106.42],
  ["Mbabane","SZ","Africa/Mbabane",-26.3,31.1],
  ["McMurdo","AQ","Antarctica/McMurdo",-77.83,166.6],
  ["Medellín","CO","America/Bogota",6.24,-75.58],
  ["Melbourne","AU","Australia/Melbourne",-37.82,144.97],
  ["Mendoza","AR","America/Argentina/Mendoza",-32.88,-68.82],
  ["Menominee","US","America/Menominee",45.11,-87.61],
  ["Merida","MX","America/Merida",20.97,-89.62],
  ["Metlakatla","US","America/Metlakatla",55.13,-131.58],
  ["Mexico City","MX","America/Mexico_City",19.4,-99.15],
  ["Miami","US","America/New_York",25.76,-80.19],
  ["Midway","UM","Pacific/Midway",28.22,-177.37],
  ["Milan","IT","Europe/Rome",45.46,9.19],
  ["Minneapolis","US","America/Chicago",44.98,-93.27],
  ["Minsk","BY","Europe/Minsk",53.9,27.57],
  ["Miquelon","PM","America/Miquelon",47.05,-56.33],
  ["Mogadishu","SO","Africa/Mogadishu",2.07,45.37],
  ["Monaco","MC","Europe/Monaco",43.7,7.38],
  ["Moncton","CA","America/Moncton",46.1,-64.78],
  ["Monrovia","LR","Africa/Monrovia",6.3,-10.78],
  ["Monterrey","MX","America/Monterrey",25.67,-100.32],
  ["Montevideo","UY","America/Montevideo",-34.91,-56.21],
  ["Monticello","US","America/Kentucky/Monticello",36.83,-84.85],
  ["Montreal","CA","America/Toronto",45.5,-73.57],
  ["Montserrat","MS","America/Montserrat",16.72,-62.22],
  ["Moscow","RU","Europe/Moscow",55.76,37.62],
  ["Munich","DE","Europe/Berlin",48.14,11.58],
  ["Muscat","OM","Asia/Muscat",23.6,58.58],
  ["Nairobi","KE","Africa/Nairobi",-1.28,36.82],
  ["Nashville","US","America/Chicago",36.16,-86.78],
  ["Nassau","BS","America/Nassau",25.08,-77.35],
  ["Nauru","NR","Pacific/Nauru",-0.52,166.92],
  ["Ndjamena","TD","Africa/Ndjamena",12.12,15.05],
  ["New Orleans","US","America/Chicago",29.95,-90.07],
  ["New Salem","US","America/North_Dakota/New_Salem",46.85,-101.41],
  ["New York","US","America/New_York",40.71,-74.01],
  ["Newark","US","America/New_York",40.74,-74.17],
  ["Niamey","NE","Africa/Niamey",13.52,2.12],
  ["Nicosia","CY","Asia/Nicosia",35.17,33.37],
  ["Niue","NU","Pacific/Niue",-19.02,-169.92],
  ["Nome","US","America/Nome",64.5,-165.41],
  ["Norfolk","NF","Pacific/Norfolk",-29.05,167.97],
  ["Noronha","BR","America/Noronha",-3.85,-32.42],
  ["Nouakchott","MR","Africa/Nouakchott",18.1,-15.95],
  ["Noumea","NC","Pacific/Noumea",-22.27,166.45],
  ["Novokuznetsk","RU","Asia/Novokuznetsk",53.75,87.12],
  ["Novosibirsk","RU","Asia/Novosibirsk",55.03,82.92],
  ["Nuuk","GL","America/Nuuk",64.18,-51.73],
  ["Ojinaga","MX","America/Ojinaga",29.57,-104.42],
  ["Omsk","RU","Asia/Omsk",55,73.4],
  ["Oral","KZ","Asia/Oral",51.22,51.35],
  ["Orlando","US","America/New_York",28.54,-81.38],
  ["Oslo","NO","Europe/Oslo",59.92,10.75],
  ["Ouagadougou","BF","Africa/Ouagadougou",12.37,-1.52],
  ["Pago Pago","AS","Pacific/Pago_Pago",-14.27,-170.7],
  ["Palau","PW","Pacific/Palau",7.33,134.48],
  ["Palmer","AQ","Antarctica/Palmer",-64.8,-64.1],
  ["Panama","PA","America/Panama",8.97,-79.53],
  ["Paramaribo","SR","America/Paramaribo",5.83,-55.17],
  ["Paris","FR","Europe/Paris",48.87,2.33],
  ["Paterson","US","America/New_York",40.92,-74.17],
  ["Perth","AU","Australia/Perth",-31.95,115.85],
  ["Petersburg","US","America/Indiana/Petersburg",38.49,-87.28],
  ["Philadelphia","US","America/New_York",39.95,-75.17],
  ["Phnom Penh","KH","Asia/Phnom_Penh",11.55,104.92],
  ["Phoenix","US","America/Phoenix",33.45,-112.07],
  ["Pitcairn","PN","Pacific/Pitcairn",-25.07,-130.08],
  ["Pittsburgh","US","America/New_York",40.44,-79.99],
  ["Piura","PE","America/Lima",-5.19,-80.63],
  ["Podgorica","ME","Europe/Podgorica",42.43,19.27],
  ["Pohnpei","FM","Pacific/Pohnpei",6.97,158.22],
  ["Pontianak","ID","Asia/Pontianak",-0.03,109.33],
  ["Port Moresby","PG","Pacific/Port_Moresby",-9.5,147.17],
  ["Port of Spain","TT","America/Port_of_Spain",10.65,-61.52],
  ["Port-au-Prince","HT","America/Port-au-Prince",18.53,-72.33],
  ["Portland","US","America/Los_Angeles",45.52,-122.68],
  ["Porto Velho","BR","America/Porto_Velho",-8.77,-63.9],
  ["Porto-Novo","BJ","Africa/Porto-Novo",6.48,2.62],
  ["Prague","CZ","Europe/Prague",50.08,14.43],
  ["Providence","US","America/New_York",41.82,-71.41],
  ["Puebla","MX","America/Mexico_City",19.04,-98.21],
  ["Puerto Rico","PR","America/Puerto_Rico",18.47,-66.11],
  ["Punta Arenas","CL","America/Punta_Arenas",-53.15,-70.92],
  ["Pyongyang","KP","Asia/Pyongyang",39.02,125.75],
  ["Qatar","QA","Asia/Qatar",25.28,51.53],
  ["Qostanay","KZ","Asia/Qostanay",53.2,63.62],
  ["Quito","EC","America/Guayaquil",-0.18,-78.47],
  ["Qyzylorda","KZ","Asia/Qyzylorda",44.8,65.47],
  ["Rankin Inlet","CA","America/Rankin_Inlet",62.82,-92.08],
  ["Rarotonga","CK","Pacific/Rarotonga",-21.23,-159.77],
  ["Recife","BR","America/Recife",-8.05,-34.9],
  ["Regina","CA","America/Regina",50.4,-104.65],
  ["Resolute","CA","America/Resolute",74.7,-94.83],
  ["Reunion","RE","Indian/Reunion",-20.87,55.47],
  ["Reykjavik","IS","Atlantic/Reykjavik",64.15,-21.85],
  ["Riga","LV","Europe/Riga",56.95,24.1],
  ["Rio Branco","BR","America/Rio_Branco",-9.97,-67.8],
  ["Rio de Janeiro","BR","America/Sao_Paulo",-22.91,-43.17],
  ["Rio Gallegos","AR","America/Argentina/Rio_Gallegos",-51.63,-69.22],
  ["Riyadh","SA","Asia/Riyadh",24.63,46.72],
  ["Rome","IT","Europe/Rome",41.9,12.48],
  ["Rosario","AR","America/Argentina/Buenos_Aires",-32.94,-60.65],
  ["Rothera","AQ","Antarctica/Rothera",-67.57,-68.13],
  ["Saipan","MP","Pacific/Saipan",15.2,145.75],
  ["Sakhalin","RU","Asia/Sakhalin",46.97,142.7],
  ["Salt Lake City","US","America/Denver",40.76,-111.89],
  ["Salta","AR","America/Argentina/Salta",-24.78,-65.42],
  ["Samara","RU","Europe/Samara",53.2,50.15],
  ["Samarkand","UZ","Asia/Samarkand",39.67,66.8],
  ["San Antonio","US","America/Chicago",29.42,-98.49],
  ["San Diego","US","America/Los_Angeles",32.72,-117.16],
  ["San Francisco","US","America/Los_Angeles",37.77,-122.42],
  ["San Juan","AR","America/Argentina/San_Juan",-31.53,-68.52],
  ["San Juan","PR","America/Puerto_Rico",18.47,-66.11],
  ["San Luis","AR","America/Argentina/San_Luis",-33.32,-66.35],
  ["San Marino","SM","Europe/San_Marino",43.92,12.47],
  ["Santarem","BR","America/Santarem",-2.43,-54.87],
  ["Santiago","CL","America/Santiago",-33.45,-70.67],
  ["Santo Domingo","DO","America/Santo_Domingo",18.47,-69.9],
  ["Sao Paulo","BR","America/Sao_Paulo",-23.53,-46.62],
  ["Sao Tome","ST","Africa/Sao_Tome",0.33,6.73],
  ["Sarajevo","BA","Europe/Sarajevo",43.87,18.42],
  ["Saratov","RU","Europe/Saratov",51.57,46.03],
  ["Scoresbysund","GL","America/Scoresbysund",70.48,-21.97],
  ["Seattle","US","America/Los_Angeles",47.61,-122.33],
  ["Seoul","KR","Asia/Seoul",37.55,126.97],
  ["Seville","ES","Europe/Madrid",37.39,-5.98],
  ["Shanghai","CN","Asia/Shanghai",31.23,121.47],
  ["Simferopol","UA","Europe/Simferopol",44.95,34.1],
  ["Singapore","SG","Asia/Singapore",1.28,103.85],
  ["Sitka","US","America/Sitka",57.18,-135.3],
  ["Skopje","MK","Europe/Skopje",41.98,21.43],
  ["Sofia","BG","Europe/Sofia",42.68,23.32],
  ["South Georgia","GS","Atlantic/South_Georgia",-54.27,-36.53],
  ["Srednekolymsk","RU","Asia/Srednekolymsk",67.47,153.72],
  ["St Barthelemy","BL","America/St_Barthelemy",17.88,-62.85],
  ["St Helena","SH","Atlantic/St_Helena",-15.92,-5.7],
  ["St Johns","CA","America/St_Johns",47.57,-52.72],
  ["St Kitts","KN","America/St_Kitts",17.3,-62.72],
  ["St Lucia","LC","America/St_Lucia",14.02,-61],
  ["St Thomas","VI","America/St_Thomas",18.35,-64.93],
  ["St Vincent","VC","America/St_Vincent",13.15,-61.23],
  ["St. Louis","US","America/Chicago",38.63,-90.2],
  ["Stanley","FK","Atlantic/Stanley",-51.7,-57.85],
  ["Stockholm","SE","Europe/Stockholm",59.33,18.05],
  ["Swift Current","CA","America/Swift_Current",50.28,-107.83],
  ["Sydney","AU","Australia/Sydney",-33.87,151.22],
  ["Syowa","AQ","Antarctica/Syowa",-69.01,39.59],
  ["Tahiti","PF","Pacific/Tahiti",-17.53,-149.57],
  ["Taipei","TW","Asia/Taipei",25.05,121.5],
  ["Tallinn","EE","Europe/Tallinn",59.42,24.75],
  ["Tampa","US","America/New_York",27.95,-82.46],
  ["Tarawa","KI","Pacific/Tarawa",1.42,173],
  ["Tashkent","UZ","Asia/Tashkent",41.33,69.3],
  ["Tbilisi","GE","Asia/Tbilisi",41.72,44.82],
  ["Tegucigalpa","HN","America/Tegucigalpa",14.1,-87.22],
  ["Tehran","IR","Asia/Tehran",35.67,51.43],
  ["Tell City","US","America/Indiana/Tell_City",37.95,-86.76],
  ["Thimphu","BT","Asia/Thimphu",27.47,89.65],
  ["Thule","GL","America/Thule",76.57,-68.78],
  ["Tijuana","MX","America/Tijuana",32.53,-117.02],
  ["Tirane","AL","Europe/Tirane",41.33,19.83],
  ["Tokyo","JP","Asia/Tokyo",35.65,139.74],
  ["Tomsk","RU","Asia/Tomsk",56.5,84.97],
  ["Tongatapu","TO","Pacific/Tongatapu",-21.13,-175.2],
  ["Toronto","CA","America/Toronto",43.65,-79.38],
  ["Tortola","VG","America/Tortola",18.45,-64.62],
  ["Trenton","US","America/New_York",40.22,-74.76],
  ["Tripoli","LY","Africa/Tripoli",32.9,13.18],
  ["Troll","AQ","Antarctica/Troll",-72.01,2.53],
  ["Trujillo","PE","America/Lima",-8.11,-79.03],
  ["Tucuman","AR","America/Argentina/Tucuman",-26.82,-65.22],
  ["Tunis","TN","Africa/Tunis",36.8,10.18],
  ["Ulaanbaatar","MN","Asia/Ulaanbaatar",47.92,106.88],
  ["Ulyanovsk","RU","Europe/Ulyanovsk",54.33,48.4],
  ["Urumqi","CN","Asia/Urumqi",43.8,87.58],
  ["Ushuaia","AR","America/Argentina/Ushuaia",-54.8,-68.3],
  ["Ust-Nera","RU","Asia/Ust-Nera",64.56,143.23],
  ["Vaduz","LI","Europe/Vaduz",47.15,9.52],
  ["Valencia","ES","Europe/Madrid",39.47,-0.38],
  ["Valparaíso","CL","America/Santiago",-33.05,-71.62],
  ["Vancouver","CA","America/Vancouver",49.27,-123.12],
  ["Vatican","VA","Europe/Vatican",41.9,12.45],
  ["Vevay","US","America/Indiana/Vevay",38.75,-85.07],
  ["Vienna","AT","Europe/Vienna",48.22,16.33],
  ["Vientiane","LA","Asia/Vientiane",17.97,102.6],
  ["Vilnius","LT","Europe/Vilnius",54.68,25.32],
  ["Vincennes","US","America/Indiana/Vincennes",38.68,-87.53],
  ["Vladivostok","RU","Asia/Vladivostok",43.17,131.93],
  ["Volgograd","RU","Europe/Volgograd",48.73,44.42],
  ["Vostok","AQ","Antarctica/Vostok",-78.4,106.9],
  ["Wake","UM","Pacific/Wake",19.28,166.62],
  ["Wallis","WF","Pacific/Wallis",-13.3,-176.17],
  ["Warsaw","PL","Europe/Warsaw",52.25,21],
  ["Washington","US","America/New_York",38.91,-77.04],
  ["Whitehorse","CA","America/Whitehorse",60.72,-135.05],
  ["Winamac","US","America/Indiana/Winamac",41.05,-86.6],
  ["Windhoek","NA","Africa/Windhoek",-22.57,17.1],
  ["Winnipeg","CA","America/Winnipeg",49.88,-97.15],
  ["Yakutat","US","America/Yakutat",59.55,-139.73],
  ["Yakutsk","RU","Asia/Yakutsk",62,129.67],
  ["Yangon","MM","Asia/Yangon",16.78,96.17],
  ["Yekaterinburg","RU","Asia/Yekaterinburg",56.85,60.6],
  ["Yerevan","AM","Asia/Yerevan",40.18,44.5],
  ["Zagreb","HR","Europe/Zagreb",45.8,15.97],
  ["Zurich","CH","Europe/Zurich",47.38,8.53],
];

export const CITIES: City[] = RAW.map(([name, cc, tz, lat, lon]) => ({ name, cc, tz, lat, lon }));
